if (!customElements.get('sande-home-video')) {
  customElements.define('sande-home-video', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const video = this.querySelector('video');
      if (!video) return;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      video.muted = true;
      if (reduced.matches || navigator.connection?.saveData) {
        video.pause();
      } else {
        video.play()?.catch(() => {});
      }
      reduced.addEventListener('change', () => {
        if (reduced.matches) video.pause();
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.querySelector('video')?.pause();
    }
  });
}
